import { Carousel } from 'react-responsive-carousel';
import UserStatusCircleProgress from '../UserStatusCircleProgress/UserStatusCircleProgress';
import { useSelector } from 'react-redux';
import { getAppUser } from '../../../app/appSelectors';
import { useCallback, useMemo } from 'react';
import {
    UserStatusesCarouselDotsSkeletonStyled,
    UserStatusesCarouselItemBackgroundStyled,
    UserStatusesCarouselItemStyled,
    UserStatusesCarouselStyled,
} from './styled/UserStatusesCarouselStyled';
import _ from 'lodash';
import { IUserStatus, TUserStatuses } from '../UserStatuses.t';
import { USER_STATUSES_CONFIG, USER_STATUSES_STATES } from '../userStatusesConstants';
import { getIsLocationPlatformDesktopSelector } from '../../Location/locationSelectors';
import ButtonMove from '../../../components/ButtonMove/ButtonMove';

interface IUserStatusesCarouselProps {
    className?: string,
    onChangeStatus: (status: TUserStatuses) => void,
    selectedStatus: TUserStatuses,
    userStatuses: IUserStatus[],
}

function UserStatusesCarousel(props: IUserStatusesCarouselProps) {
    const { className, onChangeStatus, selectedStatus, userStatuses } = props;
    const user = useSelector(getAppUser);
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);
    const selectedStatusIndex = useMemo(() =>
            _.findIndex(userStatuses, item => item.status_name === selectedStatus),
        [selectedStatus, userStatuses]);

    const onChangeHandler = useCallback((index: number) => {
        const status = userStatuses[index].status_name;
        onChangeStatus(status);
    }, [onChangeStatus, userStatuses]);

    return <UserStatusesCarouselStyled className={className}>
        {
            !userStatuses.length
                ? <div className={'d-flex flex-column align-items-center'}>
                    <UserStatusCircleProgress
                        radius={48}
                        width={4}
                        showSkeleton
                    />
                    <UserStatusesCarouselDotsSkeletonStyled className={'wave-background'}/>
                </div>
                : <Carousel
                    emulateTouch
                    onChange={onChangeHandler}
                    preventMovementUntilSwipeScrollTolerance
                    selectedItem={selectedStatusIndex}
                    showArrows={isDesktop}
                    renderArrowPrev={(onClickHandler, hasPrev) => isDesktop &&
                        <ButtonMove className={'arrow-left'} disabled={!hasPrev} direction={'left'}
                                    onClick={onClickHandler}/>}
                    renderArrowNext={(onClickHandler, hasNext) => isDesktop &&
                        <ButtonMove className={'arrow-right'} disabled={!hasNext} direction={'right'}
                                    onClick={onClickHandler}/>}
                    showIndicators
                    showStatus={false}
                    showThumbs={false}
                >
                    {
                        userStatuses.map((userStatusItem, index) => {
                            const config = USER_STATUSES_CONFIG[userStatusItem.status_name];
                            if (!config) return null;
                            const progress = userStatusItem.status_state === USER_STATUSES_STATES.PROGRESS
                                ? user.user_turnover_percent
                                : userStatusItem.status_state === USER_STATUSES_STATES.COMPLETED
                                    ? 100
                                    : 0;

                            return <UserStatusesCarouselItemStyled key={userStatusItem.status_name}>
                                <UserStatusesCarouselItemBackgroundStyled
                                    background={USER_STATUSES_CONFIG[userStatusItem.status_name].carouselBackground}/>
                                <UserStatusCircleProgress
                                    progress={config.hideProgress ? undefined : progress}
                                    state={userStatusItem.status_state}
                                    userStatus={userStatusItem.status_name}
                                    radius={48}
                                    width={4}
                                />
                            </UserStatusesCarouselItemStyled>;
                        })
                    }
                </Carousel>
        }
    </UserStatusesCarouselStyled>;
}

export default UserStatusesCarousel;
